(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name flightWatch.directive:flightWatchSearch
     * @restrict EA
     * @element
     *
     */
    angular
        .module('flightWatch')
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
        .directive('flightWatchSearch', flightWatchSearch);

    function flightWatchSearch(EventManagerService) {
        return {
            restrict: 'EA',
            scope: {
                openSearchArea: '&',
                airportList : '=',
                baseList :'=',
                aircraftTypes:'=',
                onSearchFlight :'&',
                searchParams : '='
            },
            templateUrl: 'flight-watch/directives/flight-watch-search-directive.tpl.html',
            replace: false,
            controllerAs: 'flightWatchSearch',
            bindToController: true,

            controller: ['$scope', function () {
                var vm = this;
                vm.showSearchArea = false;
                vm.fromDateAfterToDate = false;
                vm.largerSearchPeriod = false;
                vm.model = {
                    fromDate :'',
                    toDate : '',
                    selectedAirport : {airPortCode:''},
                    base:{airPortCode:''},
                    timeZone:'UTC',
                    viewOption:'ALL',
                    aircraftType:{modelNumber:''},

                };
                var currentDate = moment().format('DD/MM/YYYY');
                var toDate = moment().add(1, 'd');
                vm.model.fromDate = currentDate;
                vm.model.toDate =toDate.format('DD/MM/YYYY');

                EventManagerService.registerEventListener(EventManagerService.EVENT.SPACEBAR.SET_SEARCH_PARAM, setModelBySearchParam);


                vm.setToDate = function() {
                	if (!!vm.model.fromDate) {
                		vm.model.toDate = moment(vm.model.fromDate, "DD/MM/YYYY").add(1, 'd').format("DD/MM/YYYY");
                	}
                };

                vm.changeField = function(flag){
                	if(flag == 'fromDate'){
                		vm.setToDate();
                	}
                	setDateValidationFlags();
                }

            	function setDateValidationFlags() {
        			if (!isDateFormatInvalid(vm.model.fromDate) && !isDateFormatInvalid(vm.model.toDate)) {
        				vm.fromDateAfterToDate = isDay1BeforeDay2(vm.model.toDate, vm.model.fromDate);
                if(getDatesDifference(vm.model.fromDate, vm.model.toDate) > 14) {
                  vm.largerSearchPeriod = true;
                } else {
                  vm.largerSearchPeriod = false;
                }
        			} else {
        				vm.largerSearchPeriod = false;
        				vm.fromDateAfterToDate = false;
        			}
        		}

             // validate Date
        		function isDateFormatInvalid(date) {
        			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        				return true;
        			}
        			return false;
        		}
        		;
        		// check from date and to date
        		function isDay1BeforeDay2(day1, day2) {
        			return moment(day1, "DD/MM/YYYY").isBefore(
        					moment(day2, "DD/MM/YYYY"));
        		}
        		;

                function getDatesDifference(fromDate, toDate){
                	var diff = 0;
                	if(!!fromDate && !!toDate){
                		diff = moment(toDate, "DD/MM/YYYY").diff(moment(fromDate, "DD/MM/YYYY"), 'days')
                	}
                	return diff;
                }

                vm.displaySearchArea = function () {
                    vm.showSearchArea = !vm.showSearchArea;
                    vm.openSearchArea();
                };

                vm.displaySearchArea();

                vm.datepickerOptions = {
                    dateFormat: 'DD/MM/YYYY',
                    altTarget: $("#calendarIcon")
                };

                vm.onSearchFlights = function(){
                    if (isParamValid()) {
                        vm.onSearchFlight({'searchParam': vm.model});
                        vm.showSearchArea = !vm.showSearchArea;
                    }
                };

                function isParamValid(){
    				if((!!vm.searchForm && !vm.searchForm.$valid) || vm.largerSearchPeriod || vm.fromDateAfterToDate){
    					return false;
    				}
    				return true;
                }

                function setModelBySearchParam(searchParams){
                	vm.model = searchParams;
                	vm.searchParams = vm.model;
                }

                vm.searchParams = vm.model;

                //initial search
                vm.onSearchFlights();
            }],
            link: function (scope, element, attrs,ctrl) {

            }
        };
    }
}());
